import { DhlButton as NewButton } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

/**
 * Migration wrapper for Button component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 *
 */

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Button = (props) => {
  const { children, disabled, ...rest } = props;

  return (
    <NewButton {...rest} isDisabled={disabled}>
      <ContentWrapper>{children}</ContentWrapper>
    </NewButton>
  );
};

// Maintain static properties for backward compatibility
Button.TEXT = "text";
Button.PRIMARY = "primary";
Button.SECONDARY = "outline";

Button.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

export default Button;
